<!--
 * @Description: 添加货补，商品
 * @Autor: txp
 * @Date: 2021-04-28 09:41:04
-->
<template>
  <div class="flex btn-container">
    <el-button size="mini" type="primary" @click="addshopcarspruct('2')">
      添加货补商品
    </el-button>
    <el-button size="mini" type="primary" @click="addshopcarspruct('0')">
      添加可购商品
    </el-button>
    <el-button size="mini" type="primary" @click="addshopcarspruct('3')">
      从购物车添加商品
    </el-button>
    <el-button size="mini" type="primary" @click="addshopcarspruct('4')">
      从收藏夹添加商品
    </el-button>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      bool: true //判断是否显示
    }
  },
  watch: {
    //监听变化bool
    bool() {}
  },
  components: {},
  methods: {
    // 添加商品
    addshopcarspruct(modelType) {
      this.bool = !this.bool
      this.$emit('addshopcarspruct', modelType)
    }
  }
}
</script>
<style lang="scss" scoped>
.btn-container{
  position: relative;
  bottom: -20px;
}
</style>
